<template>
  <div class="balance py-6 px-8">
    <h-header back="../customers" />
    <h3 v-if="contracts" class="mb-5 ml-11 mt-n5 grey--text display-1">
      {{ client }}
    </h3>

    <v-card outlined>
      <v-data-table
        disable-sort
        hide-default-footer
        mobile-breakpoint="20"
        :headers="headers"
        :items="contracts"
        :loading="isLoading"
        :items-per-page="itemsPerPage"
        :no-data-text="$t('appointment.table.noData')"
        :loading-text="$t('appointment.table.loading')"
      >
        <template v-slot:[`item.date_created`]="{ item }">
          <span class="text-center" v-if="item.date_created">
            {{ formatDate(item.date_created) }}
          </span>
          <span v-else>---</span>
        </template>
        <template v-slot:[`item.type`]="{ item }">
          <span class="text-center" v-if="item.type">
            {{ $t(`contract.label.subscriptionTypes.${item.type}`) }}
          </span>
          <span v-else>---</span>
        </template>
        <template v-slot:[`item.start_date`]="{ item }">
          <span class="text-center" v-if="item.start_date">
            {{ formatDate(item.start_date) }}
          </span>
          <span v-else>---</span>
        </template>
        <template v-slot:[`item.end_date`]="{ item }">
          <span class="text-center" v-if="item.end_date">
            {{ formatDate(item.end_date) }}
          </span>
          <span v-else>---</span>
        </template>
        <template v-slot:[`item.is_active`]="{ item }">
          <div>
              <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-if="item.is_active" v-bind="attrs" v-on="on" color="green" small>
                  mdi-check-bold
                </v-icon>
                <v-icon v-else v-bind="attrs" v-on="on" color="grey lighten-1" small>
                  mdi-close-thick
                </v-icon>
              </template>
              <span>{{ $t(`contract.label.isActive.${item.is_active}`) }}</span>
            </v-tooltip>
          </div>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-row>
            <v-col>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on" @click="showDetails(item.id)" small>
                    mdi-eye
                  </v-icon>
                </template>
                <span>{{ $t("contract.actions.details") }}</span>
              </v-tooltip>
            </v-col>
            <v-col v-if="!checkUserRole(['ROLE_SUPPORT'])">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on" @click="addNewCustomContract(item.id)" small>
                    mdi-book-plus-multiple-outline
                  </v-icon>
                </template>
                <span>{{ $t("contract.actions.copyContract") }}</span>
              </v-tooltip>
            </v-col>
          </v-row>
        </template>
      </v-data-table>
    </v-card>

    <h-pagination :fetch="fetchContractsByRealEstate" :fetchParams="[id]" />
    <ModalCustomContract ref="modalCustomContract"/>
  </div>
</template>

<script>
import ModalCustomContract from '@/components/customer/modals/ModalCustomContract'

import { realEstateContractHeaders } from './listHeaders/realEstateContractHeaders'
import { mapGetters, mapActions } from 'vuex'
import { catalogDateWithoutTime } from '@/util/catalog'
import { checkUserRole } from '@/util/helpers'

export default {
  name: 'RealEstateContractList',
  components: {
    ModalCustomContract
  },

  data() {
    return {
      id: this.$router.currentRoute.params.id,
      formatDate: catalogDateWithoutTime,
      headers: realEstateContractHeaders,
    }
  },

  computed: {
    ...mapGetters(['isLoading', 'contracts', 'contract', 'customer', 'itemsPerPage']),

    client() {
      return this.customer?.name
    }
  },

  methods: {
    ...mapActions(['fetchContractsByRealEstate', 'fetchContract', 'fetchCustomer']),

    showDetails(id) {
      this.$router.push(`/contract-details/${id}`)
    },

    async addNewCustomContract(contractId) {
      await this.fetchContract(contractId)
        .then(() => {
          this.$refs.modalCustomContract.openCreateModal(
            null,
            this.contract.type,
            this.contract.service_contracts,
            this.contract.start_date,
            this.contract.end_date,
            this.contract.monthly_capacity,
            this.contract.daily_capacity,
            this.contract.overuse_fee,
          )
        })
    },

    checkUserRole,
  },

  mounted() {
    this.fetchCustomer(this.id)
    this.fetchContractsByRealEstate(this.id)
  }
}
</script>
